import {useState} from "react";

export const useDataModals = () => {
    const [showNewModal, setShowNewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selected, setSelected] = useState(null);

    const handleEditClick = (data) => {
        setSelected(data);
        setShowEditModal(true);
    }
    const handleDeleteClick = (data) => {
        setSelected(data);
        setShowDeleteModal(true);
    }
    
    return {selected, 
        newModal: {
            showModal:showNewModal,
            onClick: () => {setShowNewModal(true)},
            onClose: () => {setShowNewModal(false)}
        },
        editModal: {
            showModal: showEditModal,
            onClick: handleEditClick,
            onClose: () => {setShowEditModal(false)}
        },
        deleteModal: {
            showModal: showDeleteModal,
            onClick: handleDeleteClick,
            onClose: () => {setShowDeleteModal(false)}
        }
    }
}